import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import ImageIcon from "@material-ui/icons/Image";
import WorkIcon from "@material-ui/icons/Work";
import BeachAccessIcon from "@material-ui/icons/BeachAccess";
import PersonIcon from "@material-ui/icons/Person";
import StayCurrentPortraitIcon from "@material-ui/icons/StayCurrentPortrait";
import OfflineDb from "../../db";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function CustomCaseList(row) {
  const classes = useStyles();
  const [rows] = useState(row.row.row);
  const [header] = useState(row.row.searchHeader);
  const [listOfFields, setListOfFields] = useState(null);
  const [fieldsToDisplay, setFieldsToDisplay] = useState([]);

  useEffect(() => {
    OfflineDb.getDataFromPouchDB("metaData").then((metaData) => {
      if (metaData.data != undefined) {
        setListOfFields(
          metaData.data.programs[0].programTrackedEntityAttributes
        );
      }
    });
  }, []);

  useEffect(() => {
    if (listOfFields != null) {
      let filtteredFields = listOfFields.filter(
        (obj) => obj.displayInList == true
      );
      setFieldsToDisplay(filtteredFields);
    }
  }, [listOfFields]);

  const getTranslatedLabels = (attribute) => {
    if (localStorage.getItem("locale") == "en") {
        return attribute.displayName;
    } else if (attribute.translations && attribute.translations.length > 0) {
        //debugger;
        let label = attribute.translations.filter(tanslation => tanslation.property == "NAME" && tanslation.locale == localStorage.getItem("locale"))
        if (label.length > 0) {
            return label[0].value;
        } else {
            return attribute.displayName;
        }
    }
    return attribute.displayName;
};

  const lsitView = () => {
    return (
      <>
        {fieldsToDisplay.length > 0
          ? fieldsToDisplay.map((eachFields, i) => {
            let field = eachFields;
            let fieldValue = rows[header.findIndex(x => x.column == eachFields.trackedEntityAttribute.displayName)] ? rows[header.findIndex(x => x.column == eachFields.trackedEntityAttribute.displayName)] : 'N/A'
            if(field && field.trackedEntityAttribute && field.trackedEntityAttribute.optionSet){
              field.trackedEntityAttribute.optionSet.options.map(option => {
                if(option.code == fieldValue){
                  fieldValue = getTranslatedLabels(option)
                }
              })
            }
              return (
                <p className="alerts_description_fields" key={i}>
                  {getTranslatedLabels(eachFields.trackedEntityAttribute)} :
                  {/*rows[
                    header.findIndex(
                      (x) => x.column == eachFields.trackedEntityAttribute.displayName
                    )
                  ]*/ fieldValue
                    ? /*rows[
                        header.findIndex(
                          (x) => x.column == eachFields.trackedEntityAttribute.displayName
                        )
                      ]*/ fieldValue
                    : "N/A"}
                </p>
              );
            })
          : null}
      </>
    );
  };

  const cardView = () => {
    return (
      <List className={classes.root}>
        {fieldsToDisplay.length > 0
          ? fieldsToDisplay.map((eachFields, i) => {
            let field = eachFields;
            let fieldValue = rows[header.findIndex(x => x.column == eachFields.trackedEntityAttribute.displayName)] ? rows[header.findIndex(x => x.column == eachFields.trackedEntityAttribute.displayName)] : 'N/A'
            if(field && field.trackedEntityAttribute && field.trackedEntityAttribute.optionSet){
              field.trackedEntityAttribute.optionSet.options.map(option => {
                if(option.code == fieldValue){
                  fieldValue = getTranslatedLabels(option)
                }
              })
            }
              return (
                <ListItem key={i}>
                  <ListItemAvatar>
                    <Avatar>
                      <PersonIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={fieldValue ? fieldValue : "N/A"}
                    secondary={getTranslatedLabels(eachFields.trackedEntityAttribute)}
                  />
                </ListItem>
              );
            })
          : null}
      </List>
    );
  };
  return row.viewType == "card" ? cardView() : lsitView();
}
